<template>
  <div>
    <nav>
      <router-link :to="{ name: 'your-details', params: { redirect: 'payment' } }"><el-button type="primary" icon="el-icon-arrow-left">Back to Your Details</el-button></router-link>
    </nav>
    <el-container>
      <main class="payment">
        <h2>Payment</h2>
        <table class="payment-summary">
          <tbody>
            <tr>
              <th>Amount Due</th>
              <td>
                <i18n-n :value="+order.amount" format="currency"></i18n-n>
              </td>
            </tr>
          </tbody>
        </table>
        <el-alert
          v-if="error"
          :title="error"
          type="error" />
        <div class="payment-form">
          <card class='stripe-card'
            :class='{ complete }'
            :stripe="stripeKey"
            :options='stripeOptions'
            @change='complete = $event.complete'
          />
          <el-button type="success" @click='pay' :disabled="!complete || paymentClicked" :loading="createPaymentStatus == 'pending'">Pay with credit card</el-button>
        </div>
      </main>
      <aside>
        <cart />
      </aside>
    </el-container>
  </div>
</template>

<script>
  import { Card, createPaymentMethod, handleCardAction } from 'vue-stripe-elements-plus'
  import cart from '../components/cart'
  import { mapState } from 'vuex'

	export default {
		data () {
			return {
        paymentClicked: false,
        error: null,
				complete: false,
				stripeOptions: {
          hidePostalCode: true
					// see https://stripe.com/docs/stripe.js#element-options for details
				}
			}
		},
		components: { Card, cart },
    created() {
      this.redirectIfSessionInvalid()
    },
    computed: {
      ...mapState({
        stripeKey: state => state.settings.tenant.stripe_publishable_key,
        user: state => state.session.user,
        booking: state => state.booking.booking,
        order: state => state.order.order,
        createPaymentStatus: state => state.payments.status.createPayment,
        payments: state => state.payments
      })
    },
    watch: {
      user() {
        this.redirectIfSessionInvalid()
      },
      createPaymentStatus() {
        if (this.createPaymentStatus == 'success') {
          if (this.payments.requiresAction) {
            handleCardAction(this.payments.secret).then((data) => {
              if (data.error) {
                this.error = data.error.message
                this.paymentClicked = false
              } else {
                this.$store.dispatch('payments/createPayment', {
                  payment_intent_id: data.paymentIntent.id,
                  id: this.order.id
                })
              }
            })
          } else if (this.payments.success) {
            this.$store.commit('booking/resetOptions')
            this.$router.push({name: 'summary'})
          } else {
            this.error = "There was a unexpected problem processing your payment"
            this.paymentClicked = false
          }
        } else if (this.createPaymentStatus == 'failure') {
          this.error = this.payments.error || "There was a problem processing your payment"
          this.paymentClicked = false
        }
      }
    },
		methods: {
      redirectIfSessionInvalid() {
        if (!this.user || !this.user.id)
          this.$router.push({name: 'account', params: {redirect: 'payment'}})
        else if (this.user.status != 'created')
          this.$router.push({name: 'your-details', params: {redirect: 'payment'}})
        else if (!this.booking.id)
          this.$router.push({name: 'booking'})
      },
			pay () {
        this.paymentClicked = true
        this.error = null
        createPaymentMethod('card').then((data) => {
          if (data.error) {
            this.error = data.error.message || "There was a problem with your card information"
            this.paymentClicked = false
          } else if (data && data.paymentMethod.id) {
            this.$store.dispatch('payments/createPayment', {
              payment_method_id: data.paymentMethod.id,
              id: this.order.id
            })
          } else {
            this.paymentClicked = false
          }
        })
			}
		}
	}
</script>

<style lang="scss">
  @import "../styles/settings.scss";
  @import "../styles/mixins.scss";

  .payment-summary {
    margin-bottom: 1em;
    table-layout: fixed;
    width: 100%;
    border-bottom: 1px solid #ddd;

    th {
      width: 7em;
      text-align: left;
    }
  }

  @media (min-width: $tablet-min) {
		.payment-form {
			display: flex;

			.stripe-card {
				margin-right: 0.5em;
				flex: 1;
			}
		}
	}

  @media (max-width: $mobile-max) {
		.stripe-card {
			margin-bottom: 0.5em;
		}

    .payment-form button {
      margin-top: 1em;
      width: 100%;
      height: 4em;
      @include button-big;
    }
	}

	.StripeElement {
		box-sizing: border-box;

		height: 40px;

		padding: 5px 12px;

		border: 2px solid #BFC4CC;
		border-radius: 4px;
		background-color: white;

		box-shadow: 0 1px 3px 0 #e6ebf1;
		-webkit-transition: box-shadow 150ms ease;
		transition: box-shadow 150ms ease;
	}

	.StripeElement--focus {
		box-shadow: 0 1px 3px 0 #cfd7df;
	}

	.StripeElement--invalid {
		border-color: #fa755a;
	}

	.StripeElement--webkit-autofill {
		background-color: #fefde5 !important;
	}

  nav {
    margin-bottom: 2em;
  }

  .payment .el-alert {
    margin-bottom: 1em;
  }
</style>
